module.exports = __webpack_public_path__ + "assets/media/1.bc4dec0e.wav";